import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=a2f1f4a6&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2f1f4a6')) {
      api.createRecord('a2f1f4a6', component.options)
    } else {
      api.reload('a2f1f4a6', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=a2f1f4a6&", function () {
      api.rerender('a2f1f4a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/address/Index.vue"
export default component.exports